// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hierarchy-view-switch {
  display: inline-flex;
  gap: 0.5rem;
  padding: 0.35rem;
  margin-bottom: 1rem;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.04);
}

.hierarchy-view-switch .btn {
  border-radius: 999px;
  min-width: 7.5rem;
}

.hierarchy-search {
  margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/HierarchyView/HierarchyView.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".hierarchy-view-switch {\n  display: inline-flex;\n  gap: 0.5rem;\n  padding: 0.35rem;\n  margin-bottom: 1rem;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.hierarchy-view-switch .btn {\n  border-radius: 999px;\n  min-width: 7.5rem;\n}\n\n.hierarchy-search {\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
